module.exports = __webpack_public_path__ + "static/media/logo-bk-text.547600dd.svg";